<template>
  <div>
    <div class="info" v-if="!edit && !mover && !typer">
      <controls
        v-if="canEdit"
        :question="question"
        @edit="showEdit"
        @remove="remove"
        @mover="showMove"
        @typer="showTyper"
      ></controls>

      <h4 class="question-title">
        <span v-if="question.required">*</span>
        {{ question.title }}
        <small class="has-text-grey-light">[{{ question.weight }}]</small>
      </h4>

      <div class="question-body">
        <div class="question-field">
          <i class="fa fa-dollar"></i> {{ question.fields.amount }}
          <div class="field-placeholder">&nbsp;</div>
        </div>
      </div>
    </div>

    <div class="edit" v-if="edit && !mover && !typer">
      <form @submit.prevent="onSubmit">
        <div class="field">
          <label class="label">Title</label>
          <div class="control has-icons-right mt-2">
            <input
              type="text"
              :class="['input', { 'is-danger': errors['title'] }]"
              v-model="data['title']"
              name="title"
              required
            />
            <span class="icon is-small is-right" v-if="errors['title']"
              ><i class="fa fa-warning"></i
            ></span>
          </div>
          <p v-if="errors['title']" class="help is-danger">
            {{ errors["title"] }}
          </p>
        </div>

        <div class="field">
          <label class="label">Amount</label>
          <div class="control has-icons-right mt-2">
            <input
              type="tel"
              :class="['input', { 'is-danger': errors['fields'] }]"
              v-model="data.fields.amount"
              name="fields"
              required
            />
            <span class="icon is-small is-right" v-if="errors['fields']"
              ><i class="fa fa-warning"></i
            ></span>
          </div>
          <p v-if="errors['fields']" class="help is-danger">
            {{ errors["fields"] }}
          </p>
        </div>

        <div class="field">
          <label class="label">Weight</label>
          <div class="control has-icons-right mt-2 select is-fullwidth">
            <select name="weight" v-model="data['weight']">
              <option v-for="weight in weights" v-bind:value="weight.value"
                >[{{ weight.value }}] {{ weight.label }}</option
              >
            </select>
            <span class="icon is-small is-right" v-if="errors['title']"
              ><i class="fa fa-warning"></i
            ></span>
          </div>
          <p v-if="errors['title']" class="help is-danger">
            {{ errors["title"] }}
          </p>
        </div>

        <div class="field">
          <label class="label">Required</label>
          <div class="control has-icons-right mt-2 select is-fullwidth">
            <select
              name="required"
              v-model="data['required']"
              :disabled="question.interviewMandatory"
            >
              <option v-for="required in yesNo" :value="required.value">
                {{ required.label }}
              </option>
            </select>
            <span class="icon is-small is-right" v-if="errors['title']"
              ><i class="fa fa-warning"></i
            ></span>
          </div>
          <p v-if="errors['title']" class="help is-danger">
            {{ errors["title"] }}
          </p>
        </div>

        <div class="field is-grouped mt2 has-text-right">
          <div class="control">
            <button
              :class="['button', 'is-primary', { 'is-loading': loading }]"
            >
              Update
            </button>
            <button
              type="button is-link"
              class="button"
              v-on:click="hideEdit()"
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    </div>

    <question-move
      v-if="mover"
      :question="question"
      @hide="hideMove"
    ></question-move>
    <question-type
      v-if="typer"
      :question="question"
      @hide="hideTyper"
    ></question-type>
  </div>
</template>

<script>
import baseQuestion from "./baseQuestion";
import RoutingRules from "../routing_rules/RoutingRules";

export default {
  name: "file",

  mixins: [baseQuestion]
};
</script>

<style lang="scss" scoped></style>
